import React from 'react';

import { useSelector } from 'react-redux';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';

import { TeacherReserveInactive } from './-inactive/teacher-reserve-inactive';
import { TeacherReserveActive } from './-active/teacher-reserve-active';

export function TeacherReserve() {
    const teacherReserveInactive = useSelector(getFeatureFlags)?.teacherReserveInactive;

    return teacherReserveInactive ? <TeacherReserveInactive /> : <TeacherReserveActive />;
}
